// pages/Unauthorized.js
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const Unauthorized = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      textAlign="center"
      gap={2}
    >
      <Typography variant="h3" color="error">
        🚫 Access Denied
      </Typography>
      <Typography variant="body1">
        You don’t have permission to view this page.
      </Typography>
      <Button variant="contained" color="primary" component={Link} to="/">
        Go Home
      </Button>
    </Box>
  );
};

export default Unauthorized;
